import { Box } from "@mui/material";
import React from "react";
import ProjectsTable from "../../components/CriteriaTable/ProjectsTable";
import { useSelector } from "react-redux";
import ProjectDetails from "../ProjectDetails";

export const ProjectsWrapper = () => {
    const currentProject = useSelector((state:any) => state.actionPlan.selectedProject);    

    return(
        <Box sx={currentProject != null && Object.keys(currentProject).length ? {display: "flex", mt: 1, height: 'calc(100% - 47px)'} : { mt: 1, height: 'calc(100% - 47px)' }}>
            <ProjectsTable />
            {(currentProject != null && Object.keys(currentProject).length > 0) && <ProjectDetails />}
        </Box> 
    );
}